import './index.sass';
import { loadNew } from '~/blocks/grid';
import axios from "axios";

export default ($root) => {
    $('#mart-more-btn').click(function() {
        var moreButton, remoteUrl;
        moreButton = $(this);
        remoteUrl = $(this).attr('href');
        $root.find('.js-grid-container').append('<div class="list-loader list-loader--grid"></div>')
        axios.get(remoteUrl).then((response) => {
            const data = response.data;
            moreButton.attr('href', data.url);
            const $products = $(data.products);
            $products.addClass('grid-hidden');
            $('#products-container').append($products);
            loadNew($products)
            $('.pagination').html(data.pagination);
            return $('#mart-more-btn').toggle(!data.last_page);
        });
    });
}
